module.exports = __webpack_public_path__ + "static/media/16UNODC24.3b23350a.jpg";